var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('activity-wrapper', [_c('section', [!_vm.shouldShowKeyboard && _vm.currentRound.questionHtml ? _c('activity-question', {
    attrs: {
      "textHtml": _vm.currentRound.questionHtml,
      "answers": _vm.currentRound.answers,
      "tableData": _vm.currentRound.table,
      "image": _vm.currentRound.image,
      "numOfAttempts": _vm.numberOfAttempts[0] || 0,
      "shouldShowHints": _vm.activityStatus.showHints
    }
  }) : _vm._e(), !_vm.shouldShowKeyboard ? _c('multi-select-check-boxes', {
    attrs: {
      "answers": _vm.currentRound.answers,
      "lockedAnswers": _vm.lockedCheckBoxSelections,
      "resetCheckBoxAfterErrors": true,
      "showErrors": _vm.activityStatus.showErrors,
      "showHints": _vm.activityStatus.showHints,
      "showSuccess": true
    },
    on: {
      "onCheckBoxesSelectionChange": _vm.handleOnCheckBoxesSelectionChange
    }
  }) : _vm._e(), _vm.shouldShowKeyboard ? _c('div', {
    attrs: {
      "id": "textContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "steps"
    }
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound.typeOverText.directionsHtml
    }
  }), _c('text-display-list', {
    attrs: {
      "id": "input",
      "text-size": "medium-large"
    }
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.typeOverText.text,
      "text-step": 0
    }
  })], 1)], 1)]) : _vm._e(), _vm._t("keyboard")], 2), _vm.showActivityNextSectionPortal ? _c('activity-next-section-portal', {
    attrs: {
      "handleOnActivitySubmit": _vm.handleOnActivitySubmit
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }